<template>
  <div style="height:100%;overflow: hidden;">
    <div class="col-12" style="height: 90%;overflow: hidden scroll;margin-top:1em;" v-if="signedConsents && signedConsents.length > 0">
      <div class="col-12 prescription-list" v-for="signedConsent in signedConsents" :key="signedConsent._id">
        <div @click="viewFile(signedConsent)">
          <div class="col-12">
            <div class="row">
              <div class="col-2 col-md-1 col-lg-3" style="display: flex;justify-content: center;align-items: center;">
                <i class="el-icon-tickets prescription-icon"></i>
              </div>
              <div class="col-10 col-md-11 col-lg-9">
                <p class="card-heading reason">
                  {{ signedConsent.name }}
                </p>
                <p class="card-heading" style="margin-bottom: 0px;">
                  {{
                                        getFormattedDate(signedConsent.created)
                                      }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="col-12" style="text-align:center;margin-top:1em">
      <i class="fa fa-info-circle"></i> No signed informed consents found
    </div>

    <modal :show.sync="SHOW_CONSENTS" headerclasses="justify-content-center" modalClasses="h-100 m-0" modalContentClasses="h-100" bodyClasses="pt-2 bg-white" footerClasses="bg-white">
      <h6 slot="header" class="title title-up" style="margin-bottom: 1em;">Informed Consents</h6>
      <n-button v-if="!editing" @click.native="initEditor" slot="header" type="primary" simple round style="position: absolute;margin: 0px;top: 1em;right: 5em;">
        Edit
      </n-button>
      <n-button v-if="editing" slot="header" type="primary" round style="position: absolute;margin: 0px;top: 1em;right: 5em;" @click.native="save">
        Save
      </n-button>
      <div class="consents-dropdown" v-if="consents && consents.length > 0 && !editing">
        <drop-down :title="selectedConsent.name" tag="li" position="right" class="nav-item">
          <a class="dropdown-item" style="color:var(--color-primary)" @click="selectedConsent=consent" v-for="consent in consents" :key="consent._id">{{consent.name}}</a>
        </drop-down>
      </div>
      <div style="height: 83vh;overflow: hidden scroll;margin-top:1em" v-if="consents && consents.length > 0 && selectedConsent && !editing">
        <dynamic-image :file-id="selectedConsent.header" image-class="mb-4" image-style="margin: auto; display: block" v-if="selectedConsent.header">
        </dynamic-image>
        <p id="informed-consent" v-html="selectedConsent.html"></p>
        <dynamic-image :file-id="selectedConsent.footer" image-class="mb-4" image-style="margin: auto; display: block" v-if="selectedConsent.footer">
        </dynamic-image>

        <p>Signature</p>
        <vue-signature ref="signature" style="border: solid;" :sigOption="signaturePadOptions" :w="'225px'" :h="'140px'" :disabled="false"></vue-signature>

        <div class="col-12 text-center">
          <n-button type="primary" simple round @click.native="$refs.signature.clear()">
            <h6 class="m-0">
              {{ $t("message.Clear") }}
            </h6>
          </n-button>
          <n-button type="primary" round @click.native="agreeConsent">
            <h6 class="m-0">{{ $t("message.Agree") }}</h6>
          </n-button>
        </div>
      </div>
      <div v-if="!consents || consents.length == 0 && !editing" class="col-12" style="text-align:center">
        No informed consents found
      </div>
      <div style="height: 86vh;overflow: hidden scroll;margin-top:1em" v-if="editing">
        <div ref="editor"></div>
      </div>
    </modal>

    <n-button type="primary" round style="bottom: 0%;left: 50%;transform:translate(-50%);position: absolute;" @click.native="SHOW_CONSENTS=true">
      <i class="fa fa-plus pr-1"></i>
      Sign new consent
    </n-button>
  </div>
</template>

<script>
import InformedConsentService from "../../../services/informed-consents";
import Quill from "quill";
import "quill/dist/quill.core.css";
import "quill/dist/quill.bubble.css";
import "quill/dist/quill.snow.css";

export default {
  name: "consent-management",

  data() {
    return {
      signaturePadOptions: {
        penColor: "rgb(0, 0, 0)",
        backgroundColor: "rgb(255,255,255)",
      },
      consents: [],
      SHOW_CONSENTS: false,
      selectedConsent: { name: "" },
      editing: false,
      editor: null,
      signedConsents: [],
    };
  },

  watch: {
    selectedConsent: function () {
      if (this.$refs.signature) {
        this.$refs.signature.clear();
      }
    },
    SHOW_CONSENTS: async function (v) {
      if (!v) {
        this.consents = [];
        this.selectedConsent = { name: "" };
        this.editing = false;
        this.editor = null;
        this.consents = await this.$store.dispatch("getInformedConsents");
        if (this.consents && this.consents.length > 0) {
          this.selectedConsent = this.consents[0];
        }
      }
    },
    editing: function (v) {
      if (!v) {
        let elements = document.getElementsByClassName("ql-toolbar");
        while (elements.length > 0) {
          elements[0].parentNode.removeChild(elements[0]);
        }
        elements = document.getElementsByClassName("ql-tooltip");
        while (elements.length > 0) {
          elements[0].parentNode.removeChild(elements[0]);
        }
        elements = document.getElementsByClassName("ql-editor");
        while (elements.length > 0) {
          elements[0].parentNode.removeChild(elements[0]);
        }
        elements = document.getElementsByClassName("ql-clipboard");
        while (elements.length > 0) {
          elements[0].parentNode.removeChild(elements[0]);
        }
      }
    },
  },

  methods: {
    async agreeConsent() {
      if (!this.$refs.signature.isEmpty()) {
        let loader = this.$loading.show();
        InformedConsentService.getDataURL(
          this.$refs.signature.save("image/jpeg"),
          this.selectedConsent.delta,
          this.selectedConsent.header,
          this.selectedConsent.footer,
          (dataUrl) => {
            fetch(dataUrl).then((res) => {
              res.blob().then(async (consent_blob) => {
                var d = new Date();
                var t = d.getTime();

                try {
                  let response = await this.$store.dispatch(
                    "getPresignedUrl",
                    "consent-" + t + ".pdf"
                  );
                  await this.$store.dispatch("saveFileToMinio", {
                    url: response.url,
                    file: consent_blob,
                  });

                  let fileDetails = {
                    type: "pdf",
                    fileId: response.fileId,
                  };

                  await this.$store.dispatch("addConsent", {
                    fileID: fileDetails.fileId,
                    consentID: this.selectedConsent._id,
                    userId: this.patient._id,
                    name: this.selectedConsent.name,
                  });
                  this.SHOW_CONSENTS = false;
                  loader.hide();
                  swal.fire({
                    type: "success",
                    text: "Consent saved!",
                    title: "Success",
                  });

                  this.getSignedConsents();
                } catch {
                  loader.hide();
                  swal.fire({
                    type: "error",
                    text: "Couldn't save!",
                    title: "Error",
                    timer: 5000,
                  });
                }
              });
            });
          }
        );
      } else {
        swal.fire({
          type: "warning",
          title: "Signature is required!",
          timer: 3000,
        });
      }
    },
    async getSignedConsents() {
      try {
        this.signedConsents = await this.$store.dispatch("getSignedConsents", {
          userId: this.patient._id,
        });
      } catch (e) {
        console.log(e);
      }
    },
    save() {
      this.editing = false;
      this.editor = null;
    },
    initEditor() {
      let that = this;
      this.editing = true;
      setTimeout(() => {
        this.editor = new Quill(this.$refs.editor, {
          modules: {
            toolbar: [
              [{ size: ["small", false, "large", "huge"] }],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],

              ["bold", "italic", "underline", "strike"],
              // ['blockquote', 'code-block'],
              ["link", "image"],
              [{ color: [] }, { background: [] }],

              [{ list: "ordered" }, { list: "bullet" }],
              // [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
              [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
              [{ direction: "rtl" }], // text direction

              [{ align: [] }],
            ],
          },
          theme: "snow",
          placeholder: "Start typing...",
        });
        this.editor.root.innerHTML = this.selectedConsent.html;
        this.editor.on(
          "text-change",
          function (content, delta, source, editor) {
            that.selectedConsent.html = that.editor.root.innerHTML;
            that.selectedConsent.delta = delta;
          }
        );
      }, 500);
    },
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY, hh:mm a");
    },
    async viewFile(consent) {
      try {
        let loader = this.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        let fileId = consent.fileID;
        //get file from server
        let fileArrayBuffer = await this.$store.dispatch("getFile", fileId);

        let pdfBlob = new Blob([fileArrayBuffer]);

        let storageLocation = "";

        if (typeof device !== "undefined") {
          switch (device.platform) {
            case "Android":
              storageLocation = cordova.file.externalDataDirectory;
              break;

            case "iOS":
              storageLocation = cordova.file.documentsDirectory;
              break;
          }

          let folderPath = storageLocation;

          window.resolveLocalFileSystemURL(
            folderPath,
            function (dir) {
              dir.getFile(
                fileId,
                {
                  create: true,
                },
                function (file) {
                  file.createWriter(
                    function (fileWriter) {
                      fileWriter.write(pdfBlob);

                      fileWriter.onwriteend = function () {
                        var url = file.nativeURL; //file.toURL();
                        cordova.plugins.fileOpener2.open(url, pdfBlob.type, {
                          error: function error(err) {
                            console.error(err);
                            loader.hide();
                            alert(this.$t("message.Unable to download"));
                          },
                          success: function success() {
                            loader.hide();
                            console.log("success with opening the file");
                          },
                        });
                      };

                      fileWriter.onerror = function (err) {
                        loader.hide();
                        alert(this.$t("message.Unable to download"));
                        console.error(err);
                      };
                    },
                    function (err) {
                      loader.hide();
                      // failed
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  loader.hide();
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            },
            function (err) {
              loader.hide();
              alert(this.$t("message.Unable to download"));
              console.error(err);
            }
          );
        }
      } catch (e) {
        loader.hide();
        console.log(e);
      }
    },
  },

  async mounted() {
    this.getSignedConsents();
    this.consents = await this.$store.dispatch("getInformedConsents");
    if (this.consents && this.consents.length > 0) {
      this.selectedConsent = this.consents[0];
    }
  },

  computed: {
    patient() {
      return this.$store.state.patient;
    },
  },
};
</script>

<style scoped>
/deep/ .consents-dropdown .dropdown {
  width: 100%;
  border: #0000008c solid 0.5px;
  border-radius: 2em;
}
/deep/.consents-dropdown .nav-link {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.prescription-list {
  padding-bottom: 0.5em;
  padding-top: 0.5em;
  border-top: 1px solid #d6d0d0;
}
.prescription-list:first-child {
  border-top: none;
}
.prescription-list.selected {
  background-color: whitesmoke;
}
.prescription-icon {
  color: #2ca8ff;
  font-size: 2em;
}
.reason {
  font-size: 1.2em;
  margin-bottom: 2px;
}
.ql-container {
  height: 83%;
}
</style>
